import React from 'react';
import PropTypes from 'prop-types';
import { Header, Pagination } from './components';
import Column from './components/column';
import Row from './components/row';
import { TableLoader } from '../loaders';

const Table = (props) => {
  const {
    rows,
    columns,
    sorts,
    appliedSorts,
    searchText,
    onChange,
    totalPages,
    selectedPage,
    pageSize,
    showSearch,
    headerActionItems,
    actionItems,
    onClickActionItem,
    className,
    hasPagination,
    loading,
  } = props;

  const renderHeader = (column) => (
    <Column column={column}
      appliedSorts={appliedSorts} />
  );
  const renderRow = (col, row, index) => (
    <Row column={col}
      row={row}
      actionItems={actionItems}
      onClickActionItem={onClickActionItem}
      index={index} />
  );

  return (
    <div className={`table-container flex flex-col ${className}`}>
      <Header
        showSearch={showSearch}
        sorts={sorts}
        searchText={searchText}
        appliedSorts={appliedSorts}
        onChange={onChange}
        headerItems={headerActionItems}
      />
      <div className="table-wrapper flex flex-col shadow-xs rounded-xl">
        <div className="table-">
         {loading ?
            <TableLoader/>
          :
            <table>
              <thead>
                <tr>
                  {columns?.map((column) => (
                    <th
                      key={column?.field}
                      className="header-data"
                    >
                      {renderHeader(column)}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows?.map((row, index) => (
                  <tr key={index}>
                    {columns.map((col) => (
                      <td key={`${col?.field}-${index}`}>
                        {renderRow(col, row, index)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
        }
        </div>
        {hasPagination && (<Pagination
          totalPages={totalPages}
          selectedPage={selectedPage}
          pageSize={pageSize}
          onChange={(pageNo) => onChange('page_no', pageNo)}
        />)}
      </div>
    </div>
  );
};

Table.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape()),
  columns: PropTypes.arrayOf(PropTypes.shape()),
  sorts: PropTypes.arrayOf(PropTypes.shape()),
  appliedSorts: PropTypes.shape({}),
  searchText: PropTypes.string,
  onChange: PropTypes.func,
  totalPages: PropTypes.number,
  selectedPage: PropTypes.number,
  pageSize: PropTypes.number,
  showSearch: PropTypes.bool,
  headerActionItems: PropTypes.arrayOf(PropTypes.shape()),
  actionItems: PropTypes.arrayOf(PropTypes.shape()),
  onClickActionItem: PropTypes.func,
  className: PropTypes.string,
  hasPagination: PropTypes.bool,
};

Table.defaultProps = {
  rows: [],
  columns: [],
  sorts: [],
  appliedSorts: null,
  searchText: '',
  onChange: () => null,
  totalPages: 1,
  selectedPage: 1,
  pageSize: 10,
  showSearch: true,
  headerActionItems: null,
  actionItems: [],
  onClickActionItem: () => null,
  className: '',
  hasPagination: true,
};

export default Table;
